import React from "react";
import {Header} from "./Header";
import {Footer} from "./Footer";
import {getLangFromUrl} from "./Header";
import {translations} from "./Translations";
import {useSmartNavigate} from "./Main";

export const NotFound = () => {
    const lang = getLangFromUrl();
    const t = translations[lang];
    const navigate = useSmartNavigate();

    return (
        <div className={'main ' + (lang === 'he' ? "rtl" : 'ltr')} dir={lang === 'he' ? 'rtl' : 'ltr'}>
            <Header noRedirect/>
            <div className="not-found">
                <div className="not-found__code">404</div>
                <div className="not-found__title">{t.notFoundTitle}</div>
                <div className="not-found__desc">{t.notFoundDesc}</div>
                <button className="button btn btn-primary not-found__btn" onClick={() => navigate("/")}>
                    {t.notFoundBtn}
                </button>
            </div>
            <Footer/>
        </div>
    );
};
